/**
 * Accordion behavior for service drawer.
 * Toggles [data-accordion-open], aria-expanded, and panel visibility.
 * Chevron rotation via CSS (.service-accordion__item[data-accordion-open] .service-accordion__chevron).
 */
function initServiceAccordions(root = document) {
  root.querySelectorAll('.service-accordion').forEach((group) => {
    group.querySelectorAll('.service-accordion__item').forEach((item) => {
      const trigger = item.querySelector('.service-accordion__trigger');
      const panel = item.querySelector('.service-accordion__panel');

      if (!trigger || !panel) return;

      const toggle = () => {
        const isOpen = item.hasAttribute('data-accordion-open');
        const exclusive = group.hasAttribute('data-accordion-exclusive');

        if (exclusive && !isOpen) {
          group.querySelectorAll('.service-accordion__item').forEach((sibling) => {
            sibling.removeAttribute('data-accordion-open');
            const t = sibling.querySelector('.service-accordion__trigger');
            const p = sibling.querySelector('.service-accordion__panel');
            if (t) t.setAttribute('aria-expanded', 'false');
            if (p) p.hidden = true;
          });
        }

        if (isOpen) {
          item.removeAttribute('data-accordion-open');
          trigger.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        } else {
          item.setAttribute('data-accordion-open', '');
          trigger.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      };

      trigger.addEventListener('click', toggle);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initServiceAccordions());

// Re-init when service drawer opens (content may be dynamically shown)
document.addEventListener('service-drawer:open', () => {
  const drawer = document.getElementById('service-drawer');
  if (drawer) initServiceAccordions(drawer);
});
